<template>
<b-row class="intended-use no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding"  cols="12">
      <wlpHeader :pageTitle="pageTitle"></wlpHeader>
    </b-col>
  <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content-singles  no-gutters">
        <b-row class="body-sec no-gutters">
        <b-col class ="no-gutters">
          <div :class="{'Use' : $i18n.locale=='sp'}" class = "Use-en">
            <div :class="{'outer-blue-box' : $i18n.locale=='sp'}" class="outer-blue-box-en">
              <div class = "info-txt-1" :class="{'info-txt-1-sp' : $i18n.locale=='sp'}">
              <b>{{ $t('IntendedUse.info-txt-1-1') }}</b>{{ $t('IntendedUse.info-txt-1-2') }}
              </div>
              <div class = "info-txt-2">  {{ $t('IntendedUse.info-txt-2') }}</div>
            </div>
            <div class = "lower-section">
                <div class = "heading-text">{{ $t('IntendedUse.heading-text') }}</div>
                <div class = "health-care-text first-para">{{ $t('IntendedUse.first-para-1') }}<i>{{ $t('IntendedUse.first-para-2') }}</i> {{ $t('IntendedUse.first-para-3') }}</div>
                <div class = "health-care-text"> 
                {{ $t('IntendedUse.2nd-para-1') }}<i>{{ $t('IntendedUse.2nd-para-2') }}</i> {{ $t('IntendedUse.2nd-para-3') }}<i>{{ $t('IntendedUse.2nd-para-4') }}</i>{{ $t('IntendedUse.2nd-para-5') }}
                </div>
                <div class ="health-care-text"> {{ $t('IntendedUse.3rd-para') }}</div>
                <div class ="health-care-text">{{ $t('IntendedUse.4th-para-1') }}<i>{{ $t('IntendedUse.4th-para-2') }}</i></div>
 <div class ="health-care-text">{{ $t('IntendedUse.5th-para') }}</div>
              </div>
            </div>
         </b-col>
        </b-row>
      </b-row>
      
      <wlpNavigation :navButtons="['info','back','next', 'references', 'tnc']" :currentScreen="1" :btn3Absent="true" :btn4Absent="true"></wlpNavigation>
    </b-col>
  </b-col>
</b-row>
</template>
<script>
  import scrollMixin from "../mixins/scrollMixin";
  import wlpHeader from '../components/wlpHeader.vue';
  import wlpNavigation from '../components/wlpNavigation.vue';

  export default {
    name: "intendedUse",
    mixins: [scrollMixin],
    components: {
      'wlpHeader': wlpHeader,
      'wlpNavigation': wlpNavigation
    },
    mounted: function() {
      this.scrollToTop();
    },

    data() {
      return {
        pageTitle: 	this.$t('IntendedUse.pageTitle')
      };
    },
  };
</script>


<style lang="scss" scoped>
</style>
